import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef4861b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "name" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "list-item",
          key: index
        }, [
          _createElementVNode("aside", {
            onClick: ($event: any) => (_ctx.handleMemberProfileShow(item))
          }, [
            _createElementVNode("img", {
              class: "avatar",
              src: item?.avatar || 'https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png',
              onerror: "this.src='https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png'"
            }, null, 8, _hoisted_4),
            _createElementVNode("span", _hoisted_5, _toDisplayString(item?.nick || item?.userID), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.handleRoleName(item)), 1)
          ], 8, _hoisted_3),
          (item.role !== 'Owner' && _ctx.isShowDel)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "icon icon-del",
                onClick: ($event: any) => (_ctx.submit(item))
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_ctx.list.length < _ctx.total)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: "list-item",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getMore && _ctx.getMore(...args)))
          }, _toDisplayString(_ctx.$t(`TUIChat.manage.查看更多`)), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}